import { useState } from "react";
import { SwalAlert } from "../../components";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
export default () => {
  const [loading, setLoading] = useState(false);
  const userId = localStorage.getItem("userId");
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },
  });
  const userData = useSelector((state) => state.app.userData.userData);
  const baseURL = process.env.REACT_APP_BASE_URL;
  const mutationrefer = useMutation({
    mutationFn: async (referdata) => {
      const accessToken = localStorage.getItem("accessToken");
      const { data } = await axios.post(`${baseURL}/api/refer`, referdata, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return data;
    },
    onSuccess: (data) => {
      SwalAlert("Success!", data.message, "success");
      setLoading(false);
      setValue("email", "");
    },
    onError: (error) => {
      const responseData = error.response?.data?.message;
      setValue("email", "");
      setLoading(false);
      SwalAlert("Oops...", responseData, "error");
    },
  });
  const onSubmit = (data, e) => {
    setLoading(true);
    e.preventDefault();
    const payload = {
      user_id: userId,
      referred_email: data.email,
    };
    mutationrefer.mutate(payload);
  };
  // const ActivityData = [
  //     {
  //         id: 1,
  //         activityTitle: "Signed up for the account",
  //         activitytime: '12:00 am 24 feb, 2025',
  //         activitycolor: '#3DFC36',
  //     },
  //     {
  //         id: 2,
  //         activityTitle: "Rewards earned for referred member signed up",
  //         activitytime: '12:00 am 24 feb, 2025',
  //         activitycolor: '#AD52C2',
  //     },
  //     {
  //         id: 3,
  //         activityTitle: "Signed up for the account",
  //         activitytime: '12:00 am 24 feb, 2025',
  //         activitycolor: '#3DFC36',
  //     },
  //     {
  //         id: 4,
  //         activityTitle: "Job applied on job list no 543 lorem ipsum company",
  //         activitytime: '12:00 am 24 feb, 2025',
  //         activitycolor: '#23B5D3',
  //     },
  //     {
  //         id: 5,
  //         activityTitle: "Signed up for the account",
  //         activitytime: '12:00 am 24 feb, 2025',
  //         activitycolor: '#3DFC36',
  //     },
  //     {
  //         id: 6,
  //         activityTitle: "Rewards earned for referred member signed up",
  //         activitytime: '12:00 am 24 feb, 2025',
  //         activitycolor: '#D9A239',
  //     },
  // ]
  return {
    userData,
    handleSubmit,
    onSubmit,
    register,
    errors,
    loading,
    // ActivityData,
  };
};
